import { Serializable } from './serializable.interface';
import { MenuItem } from '../menu/shared/menu.model';

export class User implements Serializable<User> {
    Roles: Array<string>;
    UserId: string;
    UserName: string;
    Department: string;
    Email: string;
    SupplierNumber: string;
    ExtendedSupplierNumber: string;
    MenuItems: MenuItem[];
    IsApprover: boolean;
    isGlobalUser: boolean;
    InstructionType: number;

    deserialize(input: string): User {
        let json = JSON.parse(input);
        this.Roles = json.Roles;
        this.UserId = json.UserId;
        this.UserName = json.UserName;
        this.Department = json.Department;
        this.Email = json.Email;
        this.SupplierNumber = json.SupplierNumber;
        this.ExtendedSupplierNumber = json.ExtendedSupplierNumber;
        this.MenuItems = json.MenuItems;
        this.IsApprover = json.IsApprover;
        this.isGlobalUser = json.isGlobalUser;
        this.InstructionType = json.InstructionType;

        return this;
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/shared/user.model.ts